module.exports = __webpack_public_path__ + "img/iconnew2.8692bf15.png";